module.exports = __webpack_public_path__ + "static/media/clear_search.d423d15c.svg";